;function viewportWidth() {
    if (window.innerWidth) return window.innerWidth;
    var
        doc = document,
        html = doc && doc.documentElement,
        body = doc && (doc.body || doc.getElementsByTagName("body")[0]),
        getWidth = function (elm) {
            if (!elm) return 0;
            var setOverflow = function (style, value) {
                var oldValue = style.overflow;
                style.overflow = value;
                return oldValue || "";
            }, style = elm.style, oldValue = setOverflow(style, "hidden"), width = elm.clientWidth || 0;
            setOverflow(style, oldValue);
            return width;
        };
    return Math.max(
        getWidth(html),
        getWidth(body)
    );

}

;(function($, window, document) {

    var initializedCls = 'slick-initialized';

    $(window).on('resize orientationchange', function (){
        if (viewportWidth() > 767) {
            initVideoSlider();
        } else {
            destroyVideoSlider();
        }
    });

    $(document).ready(function (){
        if (viewportWidth() > 767) {
            initVideoSlider();
        } else {
            destroyVideoSlider();
        }
    });

    function destroyVideoSlider(){
        var $slider = $('.dbd-videos-slider');

        if($slider.hasClass(initializedCls)){
            $slider.slick('unslick');
        }
    }

    function initVideoSlider(){
        var $slider = $('.dbd-videos-slider');

        if(!$slider.hasClass(initializedCls)){
            $slider.slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                mobileFirst: true
            });
        }
    }

})(jQuery, window, document);
